var Handlebars = require("/home/jenkins/workspace/朵颐 - 发布POS前台/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return "shallow";
},"3":function(container,depth0,helpers,partials,data) {
    return "paid";
},"5":function(container,depth0,helpers,partials,data) {
    return "hasRefund";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.lambda, alias3=container.escapeExpression;

  return "<div class=\"col-md-6 col-sm-6 orderitem pitem "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.shallow : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + " "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.paid : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + " "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.hasRefund : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + " "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.shouldRefund : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\" data-id=\""
    + alias3(alias2((depth0 != null ? depth0.id : depth0), depth0))
    + "\" data-cid=\""
    + alias3(alias2((depth0 != null ? depth0.cid : depth0), depth0))
    + "\">\n    <div class=\"item-name vcenter\">"
    + alias3(alias2(((stack1 = (depth0 != null ? depth0.menuItem : depth0)) != null ? stack1.name : stack1), depth0))
    + "</div>\n    <div class=\"billDetail\">\n        <span class=\"quantity\">x "
    + alias3(alias2((depth0 != null ? depth0.quantity : depth0), depth0))
    + "</span>\n        <span class=\"price\">"
    + alias3(alias2((depth0 != null ? depth0.itemPrice : depth0), depth0))
    + "</span>\n    </div>\n\n    <h5 class=\"status "
    + alias3(__default(require("/home/jenkins/workspace/朵颐 - 发布POS前台/src/hbHelpers/toLowerCase.js")).call(alias1,(depth0 != null ? depth0.status : depth0),{"name":"toLowerCase","hash":{},"data":data}))
    + " hidden\">"
    + alias3(__default(require("/home/jenkins/workspace/朵颐 - 发布POS前台/src/hbHelpers/i18n.js")).call(alias1,(depth0 != null ? depth0._status : depth0),{"name":"i18n","hash":{},"data":data}))
    + "</h5>\n</div>";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/templates/table/BillItem.handlebars
// module id = 290
// module chunks = 0